export default class Grid {
  constructor(xs, ys) {
    this.grid = [];
    this.grid.length = xs*ys;
    this.xs = xs;
    this.ys = ys;

    // Clear the grid
    for (let i = 0; i < this.grid.length; i += 1) {
      this.grid[i] = false;
    }
  }

  get(x, y) {
    if ((x < 0 || this.xs <= x) || (y < 0 || this.ys <= y)) {
      return false;
    } else {
      return this.grid[y*this.xs+x];
    }
  }

  set(x, y, val) {
    if ((x < 0 || this.xs <= x) || (y < 0 || this.ys <= y)) {
      return;
    }

    this.grid[y*this.xs+x] = val;
  }
}
